import React from 'react';
import { heroData } from '../data/mock';
import { ArrowRight } from 'lucide-react';

const HeroSection = () => {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-[85vh] lg:min-h-[90vh] flex items-center overflow-hidden mb-[10px]">
      {/* Background Image with Responsive Scaling */}
      <div className="absolute inset-0">
        <img 
          src="https://customer-assets.emergentagent.com/job_premium-commercials/artifacts/5h1bp5r3_Hero%20Section%20Image.png"
          alt="Ramon Govea - Premium AI-powered commercial and brand film production"
          className="w-full h-full object-cover object-center"
          style={{
            objectPosition: '70% center'
          }}
        />
        {/* Multi-layer Cinematic Gradient Overlays */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0B0D10] via-[#0B0D10]/80 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0D10] via-transparent to-[#0B0D10]/20" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-12 pt-24 pb-8 lg:pt-32 lg:pb-12 w-full">
        <div className="max-w-[600px]">
          {/* Headline */}
          <h1 className="text-4xl sm:text-5xl lg:text-[56px] font-semibold text-[#F2F4F7] leading-[1.08] tracking-tight mb-6 animate-fade-in">
            {heroData.headline}
          </h1>

          {/* Subheadline */}
          <p className="text-base sm:text-lg text-[#A6AFBD] leading-relaxed mb-8 max-w-[520px] animate-fade-in-delay">
            {heroData.subheadline}
          </p>

          {/* CTA Button */}
          <button
            onClick={scrollToContact}
            className="group inline-flex items-center gap-3 bg-[#3B82F6] text-white px-7 py-4 text-base font-medium transition-all duration-300 hover:bg-[#2563EB] hover:scale-[1.02] hover:shadow-lg hover:shadow-[#3B82F6]/25 animate-fade-in-delay-2"
          >
            {heroData.ctaText}
            <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
          </button>

          {/* Proof Line */}
          <p className="mt-6 text-sm text-[#A6AFBD]/60 animate-fade-in-delay-3">
            {heroData.proofLine}
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
